import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import GenericButton from '../common/GenericButton';
import { generateButton } from '../../actions/rldToolActions';
import { exportFileTitle } from '../../util/RldAccountUtils';

const RldGenerateButton = props => {
  const dispatch = useDispatch();
  const { selectedAccount } = useSelector(state => state.rldTool.account);
  const { selectedStudy } = useSelector(state => state.rldTool.study);
  const columnSeperator = useSelector(({ rldTool }) => rldTool.columnSeperator);
  const dictionaryFileFormat = useSelector(
    ({ rldTool }) => rldTool.dictionaryFileFormat
  );

  const {
    email,
    dictionaryTarget,
    enableGenerateFile,
    successMessage,
    isDictionaryOnly,
    isAllLocalMarkets,
    fileStructureFormat,
  } = useSelector(state => ({
    email: state.rldTool.email,
    dictionaryTarget: state.rldTool.dictionary.dictionaryTarget,
    enableGenerateFile: state.rldTool.enableGenerateFile,
    successMessage: state.rldTool.successMessage,
    isDictionaryOnly: state.rldTool.isDictionaryOnly,
    isAllLocalMarkets: state.rldTool.isAllLocalMarkets,
    fileStructureFormat: state.rldTool.fileStructureFormat,
  }));

  const timestamp = exportFileTitle('DataHaul');

  const handleGenerateButton = e => {
    let weightTypeName = 'Population';
    selectedStudy.cw.map(element => {
      if (element.wt === selectedStudy.wt && !selectedStudy.dv && !element.dv) {
        weightTypeName = element.wn;
      } else if (
        element.wt === selectedStudy.wt &&
        selectedStudy.dv &&
        element.dv &&
        element.dv === selectedStudy.dv
      ) {
        weightTypeName = element.wn;
      } else if (
        element.wt === selectedStudy.wt &&
        selectedStudy.dv == 1000 &&
        !element.dv
      ) {
        weightTypeName = element.wn;
      }
    });
    const nodes = [];
    dictionaryTarget.forEach(element => {
      nodes.push(element.node);
    });
    dispatch(
      generateButton(
        props.uid,
        selectedAccount.accountId,
        selectedStudy.pn,
        selectedStudy.wt,
        weightTypeName,
        columnSeperator,
        dictionaryFileFormat,
        fileStructureFormat,
        isDictionaryOnly,
        isAllLocalMarkets,
        email,
        nodes,
        timestamp
      )
    );
  };
  return (
    <div>
      <div className="rldGenericButton">
        <GenericButton
          name="Generate file"
          onBtnClick={handleGenerateButton}
          btnDisabled={!enableGenerateFile}
        />
        <p style={{ color: 'green', display: 'inline-block' }}>
          {successMessage
            ? 'Successfully generated your requested file. Please see your email.'
            : ''}
        </p>
      </div>
    </div>
  );
};

export default RldGenerateButton;
